 import React from 'react'; 
 import ReactDOM from 'react-dom'; 
 import { Provider } from "react-redux"; 
 import store from "./data/store"; 
 import App from './App.jsx'; import "./assets/main.css";
  import 'react-toastify/dist/ReactToastify.css'; 
  import { Elements } from "@stripe/react-stripe-js"; 
  import { loadStripe } from "@stripe/stripe-js"; 
  const stripePromise = loadStripe("pk_test_51Srfi0EKsLWOmF48YXAx2ZUYIYJp1LS4HpiXzne5qkvh9KaGI0WC7EDBohhDxoQlWZUi737uyYIZrMSwMSaAXNxU00vRaVALO0"); 
  ReactDOM.render( 
  <Provider store={store}>
     <Elements stripe={stripePromise}> <App /> </Elements> 
     </Provider>,
     document.getElementById("root")
     );